const blue = {
  primary: '#2d64ff',
  bg: '#f0f6ff',
  line: '#d1e3ff',
  hover: '#5789ff',
  press: '#1c48d9',
};

const red = {
  primary: '#ff4c4c',
  bg: '#fff2f0',
  line: '#ffcdc7',
  hover: '#ff7a75',
  press: '#d9363c',
};

const yellow = {
  primary: '#feb00e',
  bg: '#fff7e1',
  line: '#ffebb3',
  hover: '#ffc72c',
  press: '#fd8c0e',
};

const green = {
  primary: '#17c574',
  bg: '#ebfff2',
  line: '#bcf7d4',
  hover: '#3bd186',
  press: '#0b9e5e',
};

const black = {
  82: 'rgba(0,0,0,0.82)',
  65: 'rgba(0,0,0,0.65)',
  45: 'rgba(0,0,0,0.45)',
  25: 'rgba(0,0,0,0.25)',
  15: 'rgba(0,0,0,0.15)',
  10: 'rgba(0,0,0,0.10)',
  6: 'rgba(0,0,0,0.06)',
  4: 'rgba(0,0,0,0.04)',
  2: 'rgba(0,0,0,0.02)',
};

export { blue, red, yellow, green, black };
